// Mock data for Drijesh Ppatel's portfolio
// This will later be replaced with backend API calls

export const profile = {
  name: "Dr. Drijesh Ppatel",
  role: "Engineering Leader · GenAI & Cyber Security Strategist",
  currentRole: "Engineering Manager at IBM",
  experience: "14+ years",
  location: "Based globally · Available worldwide",
  email: "contact@drijeshppatel.in",
  avatar: "https://customer-assets.emergentagent.com/job_portfolio-hub-2023/artifacts/7imdpaba_Drijesh.jpg",
  socials: {
    linkedin: "https://www.linkedin.com/in/drijesh",
    twitter: "https://x.com/drijesh",
    instagram: "https://www.instagram.com/drijeshtalks",
    youtube: "https://www.youtube.com/@drijeshtalks",
    medium: "https://medium.com/@drijesh",
    github: "https://github.com/drijesh-ppatel",
    topmate: "https://topmate.io/drijesh",
    orcid: "https://orcid.org/0009-0004-2265-4520",
  },
};

export const heroStats = [
  { value: "15+", label: "Years leading engineering" },
  { value: "800+", label: "Talks & keynotes delivered" },
  { value: "650+", label: "Professionals & students mentored" },
  { value: "30+", label: "Recognitions, awards & certifications" },
];

export const pillars = [
  {
    number: "01",
    title: "AI Adoption That Actually Works",
    copy: "Moving beyond experiments. Integrating AI into the SDLC, decision systems, and products so teams ship measurable outcomes, not slideware.",
    tags: ["GenAI", "SDLC", "Product AI"],
  },
  {
    number: "02",
    title: "Engineering Leadership",
    copy: "Building and mentoring teams that deliver reliable, scalable, and secure systems \u2014 with clarity, autonomy, and craft at the center.",
    tags: ["Teams", "Mentorship", "Delivery"],
  },
  {
    number: "03",
    title: "DevSecOps & Cloud Systems",
    copy: "Embedding security, automation, and resilience into modern architectures across AWS, Azure, and GCP \u2014 without slowing down velocity.",
    tags: ["DevSecOps", "Cloud", "Resilience"],
  },
];

export const authorityLogos = [
  "Times of India",
  "Gujarat Samachar",
  "BNI",
  "JBN",
  "FGI",
  "ASSOCHAM",
  "iHub",
  "ADW",
  "NFSU",
  "RRU",
  "IIT Gandhinagar",
  "CHARUSAT",
  "SKIPS",
  "Silver Oak University",
  "IBM",
  "Google",
  "Google for Developers",
  "AWS",
  "Oracle",
  "IEEE",
  "PMI",
];

export const aboutLogos = [
  "Times of India",
  "Gujarat Samachar",
  "BNI",
  "JBN",
  "FGI",
  "ASSOCHAM",
  "iHub",
  "ADW",
  "NFSU",
  "RRU",
  "IIT Gandhinagar",
  "CHARUSAT",
  "SKIPS",
  "Silver Oak University",
  "IBM",
  "Google",
  "Google for Developers",
  "AWS",
  "Oracle",
  "IEEE",
  "PMI",
  "Wipro",
  "Atos",
  "Syntel",
  "Open Source Community",
];

export const awards = [
  {
    year: "2025",
    title: "Bharat Pratibha Samman Award",
    body: "National recognition for contribution to India\u2019s tech and leadership ecosystem.",
    link: "https://foxstoryindia.com/2025/09/11/bharat-pratibha-sammaan-award-ceremony-2025-celebrates-indias-unsung-heroes-mp-shri-anurag-thakur-graces-the-event-as-the-chief-guest/",
  },
  {
    year: "2025",
    title: "Dynamic Leader of the Year",
    body: "Honored at the Global Leadership Summit 2025 alongside industry leaders, educators, and entrepreneurs.",
    link: "https://www.tribuneindia.com/news/business/mumbai-witnessed-business-leaders-educators-and-women-entrepreneurs-at-one-stage-at-the-much-anticipated-global-leadership-summit-2025/",
  },
  {
    year: "2024",
    title: "Rising Tech Expert 2024",
    body: "Featured in Heights of Success Magazine for measurable impact across AI, cloud, and cybersecurity programs.",
    link: "https://www.magzter.com/IN/height-of-success/Heights-Of-Success-Magazine/Business/1645864",
  },
  {
    year: "2024",
    title: "Partner Communities Award \u2014 Google for Developers",
    body: "Recognized for leadership and contributions to the developer community through GDG Cloud Gandhinagar.",
    link: "#",
  },
  {
    year: "2023",
    title: "20 Influential Personalities of India",
    body: "Featured among leaders breaking barriers and shaping the future across industries.",
    link: "https://www.aninews.in/news/business/business/meet-20-influential-personalities-who-are-breaking-barriers-and-shaping-the-future-in-202320231020160802/",
  },
  {
    year: "2023",
    title: "40 Under 40 \u2014 Influential Leaders",
    body: "Insights Success Magazine\u2019s curated list of tomorrow\u2019s industry shapers.",
    link: "https://magazines.insightssuccess.in/2023/the-40-under-40-influential-leaders-2023-may2023/#page=52",
  },
  {
    year: "2023",
    title: "India\u2019s 100 Future Leaders",
    body: "Glantor X\u2019s list of future leaders shaping India\u2019s next chapter.",
    link: "https://glantorx.com/2023/03/17/list-of-future-leaders-2023-by-glantor-x-released/",
  },
];

export const speakingSessions = [
  {
    title: "Expert Talk \u2014 Google DevFest Ahmedabad",
    venue: "Google DevFest",
    topic: "Generative AI in the Real Enterprise",
    url: "https://youtu.be/zhfVTGsHLNw",
  },
  {
    title: "Keynote \u2014 GDG Cloud Gandhinagar",
    venue: "Google Developers Group",
    topic: "Cloud, AI, and the Next Decade of Engineering",
    url: "https://youtu.be/VO6zNv2DQ48",
  },
  {
    title: "Build Mode On \u2014 TST Technology",
    venue: "Podcast",
    topic: "From a small town to leading engineering at IBM",
    url: "https://youtu.be/rT_TE4wmTQA",
  },
  {
    title: "Project Perks with Harkiran",
    venue: "Podcast",
    topic: "Agile Leadership in modern organisations",
    url: "https://youtu.be/KWNJx5nHimc",
  },
  {
    title: "Ayushi Rawat Talk Show",
    venue: "Podcast",
    topic: "Secure your money, data and career",
    url: "https://youtu.be/o_R9tvH-jP0",
  },
];

export const speakingTopics = [
  "Generative AI in the enterprise SDLC",
  "Building engineering teams that ship",
  "DevSecOps without slowing delivery",
  "Cloud architecture for AI workloads",
  "From individual contributor to leader",
  "Cybersecurity for the AI era",
];

export const caseStudies = [
  {
    tag: "AI in SDLC",
    title: "Embedding Generative AI across the software delivery lifecycle",
    metric: "32% faster delivery cycles",
    copy: "Re-architected the SDLC with AI copilots for code, review, testing, and documentation \u2014 without compromising security posture.",
  },
  {
    tag: "Cybersecurity",
    title: "Optimising a cybersecurity detection pipeline with ML",
    metric: "41% lower false positives",
    copy: "Tuned detection and response with a layered ML approach that balanced precision with analyst trust and operational realities.",
  },
  {
    tag: "Product AI",
    title: "AI-powered product enhancement for an enterprise platform",
    metric: "2.4x user engagement lift",
    copy: "Shipped generative features into a mature product with careful UX, guardrails, and measurable business outcomes.",
  },
];

export const publications = [
  {
    title: "A Skeptical Demeanor Revelation System Fused with Machine Learning Civil Cyber Security",
    venue: "IEEE Xplore",
    url: "https://ieeexplore.ieee.org/document/11059200",
  },
  {
    title: "Streamlining Compliance and Governance with AI in Cloud-based Programs",
    venue: "IJFMR",
    url: "https://www.ijfmr.com/research-paper.php?id=5213",
  },
  {
    title: "Revolutionizing Program Evaluation with Generative AI: An Evidence-Based Methodology",
    venue: "IJFMR",
    url: "https://www.ijfmr.com/research-paper.php?id=4105",
  },
  {
    title: "Revolutionizing Project Management with Generative AI",
    venue: "ISJEM",
    url: "https://isjem.com/download/revolutionizing-project-management-with-generative-ai/",
  },
];

export const certifications = [
  "Certified Generative AI Professional",
  "PMI \u2014 Project Management Professional (PMP)",
  "Certified Scrum Master (CSM)",
  "SAFe Agilist",
  "PMI \u2014 Agile Certified Practitioner (PMI-ACP)",
  "Google Cloud Professional Data Engineer",
  "AWS Solution Architect",
  "Microsoft Certified Azure Data Engineer",
  "Oracle Certified SQL Expert (OCE)",
  "Informatica PowerCenter Developer Specialist",
];

export const luminarc = {
  trademark: "Luminarc\u2122",
  tagline: "Where logic ends, perspective begins.",
  subtitle: "Not a Workshop. A Transformation.",
  hero: "A transformational, hands-on experience designed to develop narrative thinking in the age of AI. Not a workshop \u2014 a paradigm shift for those who need to communicate, decide, and inspire when data alone isn\u2019t enough.",
  long:
    "Luminarc\u2122 is a category-defining experience that goes beyond traditional training. It\u2019s designed for anyone who recognises that in an AI-driven world, the human capacity for narrative thinking becomes the ultimate competitive advantage. While machines excel at processing data, humans alone possess the ability to weave meaning, context, and purpose into coherent stories that inspire action.",
  pitch:
    "Luminarc\u2122 develops this uniquely human capability through immersive exercises, reflective practices, and peer collaboration in an intimate cohort setting.",
  ctaLabel: "Express interest",
  ctaUrl: "https://expertizeedge.com/contact",
  siteUrl: "https://expertizeedge.com/luminarc",
  principles: [
    { t: "Non-technical & hands-on", c: "No coding or tech background required." },
    { t: "Intimate cohort experience", c: "Limited seats for deep engagement." },
    { t: "Narrative, not numbers", c: "A human-centric approach to decisions." },
    { t: "Real-world application", c: "Immediately applicable insights and tools." },
    { t: "Post-program community", c: "An ongoing peer support network." },
    { t: "Transformational, not informational", c: "Designed to change how you think." },
  ],
  outcomes: [
    {
      t: "Structured thinking clarity",
      c: "Frameworks that cut through complexity and help you see patterns and possibilities others miss.",
    },
    {
      t: "Powerful storytelling",
      c: "Master the art of narrative to inspire action, align teams, and influence stakeholders effectively.",
    },
    {
      t: "Decision-making in uncertainty",
      c: "Build confidence in making high-stakes decisions when data alone isn\u2019t enough to guide you.",
    },
    {
      t: "Navigate AI disruption",
      c: "Understand how to lead effectively when machines can process faster than humans ever could.",
    },
  ],
  audience: [
    "CEOs & Founders",
    "C-Suite Executives",
    "VPs & Directors",
    "High-Potential Leaders",
    "Professionals",
    "Students",
  ],
  voices: [
    {
      quote:
        "Luminarc\u2122 transformed how I approach every strategic decision. The narrative thinking framework gave our entire leadership team a new lens.",
      name: "Sarah Chen",
      role: "CEO, TechVentures Inc.",
    },
    {
      quote:
        "As a student, I wasn\u2019t sure if this was for me. But the frameworks I learned have already helped me stand out in interviews and think differently about my career.",
      name: "Arjun Mehta",
      role: "MBA Student, IIM Ahmedabad",
    },
    {
      quote: "The best investment I\u2019ve made in my professional development. Period.",
      name: "Jennifer Walsh",
      role: "VP Marketing, Global Retail Co.",
    },
  ],
};

export const insights = [
  {
    tag: "AI Leadership",
    title: "Why most AI pilots fail (and the three decisions that fix it)",
    excerpt: "The tools are not the bottleneck. Decision architecture is. A field-tested breakdown.",
    date: "Jun 2025",
    read: "7 min read",
  },
  {
    tag: "DevSecOps",
    title: "Security as a velocity lever, not a tax",
    excerpt: "Reframing DevSecOps for teams that want to ship faster without waking up at 3am.",
    date: "May 2025",
    read: "9 min read",
  },
  {
    tag: "Engineering Culture",
    title: "The difference between a manager and an engineering leader",
    excerpt: "Titles are cheap. Observable behaviours are what teams actually follow.",
    date: "Apr 2025",
    read: "6 min read",
  },
  {
    tag: "GenAI",
    title: "Designing AI-native workflows inside existing enterprises",
    excerpt: "A practical pattern library for embedding GenAI into mature organisations.",
    date: "Mar 2025",
    read: "10 min read",
  },
];

export const testimonials = [
  {
    quote: "Drijesh has this rare ability to turn strategy into shipped systems. His sessions do not feel like talks \u2014 they feel like blueprints.",
    name: "Senior Engineering Director",
    org: "Enterprise SaaS",
  },
  {
    quote: "The clarity he brings to AI adoption is unusual. No hype. Just frameworks that survive contact with reality.",
    name: "Head of Platform",
    org: "FinTech",
  },
  {
    quote: "We brought him in to mentor our staff engineers. Within a quarter the way they framed problems had fundamentally changed.",
    name: "VP Engineering",
    org: "Global Bank",
  },
];

export const images = {
  speakingHero: "https://customer-assets.emergentagent.com/job_portfolio-hub-2023/artifacts/46hkqayb_speaking-1.JPG",
  speakingSecondary: "https://customer-assets.emergentagent.com/job_portfolio-hub-2023/artifacts/fyf1gd07_speaking-2.JPG",
  workshopLab: "https://images.pexels.com/photos/18471530/pexels-photo-18471530.jpeg",
  workshopClass: "https://images.pexels.com/photos/5745520/pexels-photo-5745520.jpeg",
  awardTrophy: "https://images.pexels.com/photos/7005064/pexels-photo-7005064.jpeg",
  awardPremium: "https://images.unsplash.com/photo-1650240852447-46505dba4726",
  cyberAbstract: "https://images.unsplash.com/photo-1665725045018-d734fe11e46d",
  cyberBinary: "https://images.pexels.com/photos/5473960/pexels-photo-5473960.jpeg",
};
